import { HTTP_ORGANIZATIONS, HTTP_DESKRH } from '@/http';

export default {

  getOrganizations(searchParams) {
    if (searchParams.orgID === 0 || !searchParams.orgID) {
      // eslint-disable-next-line
      delete searchParams.parentId;
      // eslint-disable-next-line
      searchParams.isRoot = true;
      return this.getAllOrganizations(searchParams)
        .then(data => ({
          organizations: data.organizations,
          count: data.count,
        }));
    }
    // eslint-disable-next-line
    delete searchParams.isRoot;
    // eslint-disable-next-line
    searchParams.parentId = searchParams.orgID;
    return this.getAllOrganizations(searchParams)
      .then(response => ({
        organizations: response.organizations,
        count: response.count,
      }));
  },

  getTopLevelOrganisations(searchParams) {
    // eslint-disable-next-line
    delete searchParams.parentId;
    return this.getAllTopLevelOrganisations(searchParams)
      .then(response => ({
        organizations: response.organizations,
        count: response.count,
      }));
  },

  getOrganization(id) {
    return HTTP_ORGANIZATIONS.get(`/${process.env.API_ORGANIZATIONS_ROUTE}/${id}`)
      .then(response => response.data.data);
  },

  getOrganizationBySiret(siret) {
    return HTTP_DESKRH.get(`/${process.env.API_ORGANIZATION_DIRECTORY}/siret/${siret}`)
      .then((response) => {
        if (response) {
          const result = {};
          result.name = response.data.data.variablesAdresse.l1_normalisee;
          result.siret = siret;
          result.address = {
            street: response.data.data.variablesAdresse.l4_normalisee,
            city: response.data.data.variablesLocalisation.libcom,
            country: response.data.data.variablesAdresse.l7_normalisee,
            postal: response.data.data.variablesLocalisation.codpos,
          };
          return result;
        }
        return null;
      });
  },

  getOrgConf(id) {
    return HTTP_ORGANIZATIONS.get(`${process.env.API_ORGANIZATIONS_ROUTE}/${id}/conf`)
      .then(response => response.data.data);
  },

  updateOrgConf(params) {
    return HTTP_ORGANIZATIONS.put(`${process.env.API_ORGANIZATIONS_ROUTE}/${params.id}/conf`, params.orgConf)
      .then(response => response.data);
  },

  updateOrgTransmissionMode(params) {
    return HTTP_DESKRH.post(`/organization/${params.id}/conf/transmission-mode`, { transmissionMode: params.transmissionMode });
  },

  updateOrgReceptionMode(params) {
    return HTTP_DESKRH.post(`/organization/${params.id}/conf/reception-mode`, { receptionMode: params.receptionMode });
  },


  getAllOrgExceptChildren(searchParams) {
    return HTTP_ORGANIZATIONS.post(`/${process.env.API_ORGANIZATIONS_LISTING_ROUTE}/nochildren/${searchParams.orgID}`, searchParams)
      .then(response => response.data);
  },

  getOrganizationAncestors(id) {
    return HTTP_ORGANIZATIONS.get(`/${process.env.API_ORGANIZATIONS_ROUTE}/${id}/ancestors`)
      .then(response => response.data.data);
  },

  getDocType(id) {
    return HTTP_ORGANIZATIONS.get(`/${process.env.API_ORGANIZATIONS_ROUTE}/${id}/conf/docType`);
  },

  getOrganizationEmployeesGroups(id) {
    return HTTP_DESKRH.get(`/${process.env.API_ORGANIZATIONS_ROUTE}/${id}`)
      .then(response => response.data.data);
  },

  getAllOrganizations(searchParams) {
    return HTTP_ORGANIZATIONS.post(`/${process.env.API_ORGANIZATIONS_LISTING_ROUTE}`, searchParams)
      .then(response => response.data.data);
  },

  getAllTopLevelOrganisations(searchParams) {
    return HTTP_ORGANIZATIONS.post(`/${process.env.API_ORGANIZATIONS_LISTING_ROUTE}/top-level`, searchParams)
      .then(response => response.data.data);
  },

  getStats() {
    return HTTP_ORGANIZATIONS.get(`/${process.env.API_ORGANIZATIONS_LISTING_ROUTE}/stats`)
      .then(response => response.data);
  },

  newOrganization(organization) {
    return HTTP_DESKRH.post(`/${process.env.API_ORGANIZATIONS_ROUTE}`, organization);
  },

  putOrganization(id, organization) {
    return HTTP_ORGANIZATIONS.put(`/${process.env.API_ORGANIZATIONS_ROUTE}/${id}`, organization);
  },

  deleteOrganization(id) {
    return HTTP_DESKRH.delete(`${process.env.API_EMPLOYEES_LISTING_ROUTE}/organization/${id}`)
      .then(response => response);
  },
};



// WEBPACK FOOTER //
// ./src/api/organizations.js